module.exports = __webpack_public_path__ + "images/dealerlabellease099131a67e1224bb2fdea2ea98b0cf69.png";